import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { initMercadoPago } from '@mercadopago/sdk-react';

const MercadoPagoInitializer = () => {
  const publicKey = useSelector(state => state.app.publicKeyMP);

  useEffect(() => {
    if (publicKey) {
      initMercadoPago(publicKey, { locale: 'es-AR' });
    }
  }, [publicKey]);

  return null;
};

export default MercadoPagoInitializer;
